import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import MeetingTypeModel from "../../models/MeetingType";
import Location from "../../models/ServiceDeliveryLocation";
import A11yHelpers from "../../util/A11yHelpers";
import { meetingSchedulerPath, meetingTeamPath, meetingTopicPath, } from "../../src/View/Pages/MeetingRequest/MeetingRequestRoutes";
class MeetingType extends Component {
    // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
    constructor(props) {
        super(props);
        // @ts-expect-error - TS2339 - Property 'virtualizedApp' does not exist on type 'MeetingType'.
        this.virtualizedApp = props.virtualizedApp;
        this.renderMeetingType = this.renderMeetingType.bind(this);
        this.renderLocation = this.renderLocation.bind(this);
    }
    // @ts-expect-error - TS7006 - Parameter 'meetingType' implicitly has an 'any' type.
    renderMeetingType(meetingType) {
        return (_jsxs("div", { className: "col-md-4 col-sm-6 my-1", children: [_jsxs("div", Object.assign({ className: "btn btn-lg " +
                        (meetingType.isSelected ? "btn-success" : "btn-outline-dark"), role: "button", tabIndex: 0, style: { width: "100%", whiteSpace: "normal" } }, A11yHelpers.onClickOrEnterOrSpace(() => this.props.selectMeetingType(meetingType)), { children: [meetingType.isSelected ? (_jsx("span", { className: "fa fa-check mr-1", "aria-hidden": "true" })) : (""), meetingType.name] })), meetingType.isSelected && meetingType.additionalInfo && (_jsx("div", { className: "mt-2 mb-3", children: meetingType.additionalInfo }))] }, meetingType.id));
    }
    // @ts-expect-error - TS7006 - Parameter 'location' implicitly has an 'any' type.
    renderLocation(location) {
        return (_jsx("div", { className: "col-md-4 col-sm-6 my-1", children: _jsxs("div", Object.assign({ className: "btn btn-lg " +
                    (location.isSelected ? "btn-success" : "btn-outline-dark"), role: "button", style: { width: "100%", whiteSpace: "normal" }, tabIndex: 0 }, A11yHelpers.onClickOrEnterOrSpace(() => this.props.selectLocation(location)), { children: [location.isSelected ? (_jsx("span", { className: "fa fa-check mr-1", "aria-hidden": "true" })) : (""), location.name] })) }, location.id));
    }
    renderPreviousButton() {
        // @ts-expect-error - TS2339 - Property 'hasMeetingWith' does not exist on type 'Readonly<Props>'.
        if (this.props.hasMeetingWith) {
            return (_jsxs(Link, { to: {
                    pathname: meetingTopicPath({}),
                    search: this.props.pageParams,
                }, className: "btn btn-outline-dark btn-lg", children: [_jsx("span", { className: "fa fa-chevron-left", "aria-hidden": "true" }), " Previous"] }));
        }
        return (_jsxs(Link, { to: {
                pathname: meetingTeamPath({}),
                search: this.props.pageParams,
            }, className: "btn btn-outline-dark btn-lg", children: [_jsx("span", { className: "fa fa-chevron-left", "aria-hidden": "true" }), " Previous"] }));
    }
    renderNextButton() {
        if (this.props.selectedMeetingType) {
            if ((this.props.selectedMeetingType.requiresLocation &&
                this.props.selectedLocation) ||
                !this.props.selectedMeetingType.requiresLocation ||
                this.props.selectedMeetingTeam) {
                return (_jsxs(Link, { to: {
                        pathname: meetingSchedulerPath({}),
                        search: this.props.pageParams,
                    }, className: "btn btn-primary btn-lg", children: ["Pick a Time", " ", _jsx("span", { className: "fa fa-chevron-right", "aria-hidden": "true" })] }));
            }
        }
        return (
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'boolean | undefined'.
        _jsxs("button", { type: "button", disabled: "true", className: "btn btn-primary btn-lg", children: ["Pick a Time ", _jsx("span", { className: "fa fa-chevron-right", "aria-hidden": "true" })] }));
    }
    renderMeetingTypes() {
        if (this.props.meetingTypes && this.props.meetingTypes.length) {
            return (_jsx("div", { className: "row", children: this.props.meetingTypes.map(this.renderMeetingType) }));
        }
        return (_jsxs("div", { className: "alert alert-warning", children: [_jsx("span", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }), " Oops! It looks like there are no meeting types available at the moment. Please check again later, or contact your advisor directly to schedule a meeting."] }));
    }
    render() {
        return (_jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsxs("div", { className: "mb-3", children: [_jsxs("h3", { className: "my-3", children: ["How would ", this.props.isThirdPartyScheduler ? "the student" : "you", " ", "like to meet?"] }), this.renderMeetingTypes()] }), this.props.enableLocationSelection && (_jsxs("div", { className: "mb-3", children: [_jsx("h3", { className: "my-3", children: "Where?" }), _jsx("div", { className: "row", children: this.props.locations.map(this.renderLocation) })] })), _jsxs("div", { className: "mb-3 d-flex justify-content-between", children: [this.renderPreviousButton(), this.renderNextButton()] })] }));
    }
}
// @ts-expect-error - TS2339 - Property 'propTypes' does not exist on type 'typeof MeetingType'.
MeetingType.propTypes = {
    enableLocationSelection: PropTypes.bool,
    hasMeetingWith: PropTypes.bool,
    locations: PropTypes.arrayOf(PropTypes.instanceOf(Location)),
    meetingTypes: PropTypes.arrayOf(PropTypes.instanceOf(MeetingTypeModel)),
    selectLocation: PropTypes.func,
    selectMeetingType: PropTypes.func,
};
export default MeetingType;
